/*
 * @Author: wsx
 * @Date: 2022-01-17 11:03:56
 * @LastEditTime: 2022-01-21 14:57:45
 * @LastEditors: your name
 * @Description: 检测视频控件
 */
import protocolCheck from "@/utils/protocolcheck.js";
import { useRouter, useRoute } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import util from "@util/js";
let isInit = false;
const router = useRouter();
const route = useRoute();

class CheckVideo {
  isInstall = false;
  isDownOpen = false;
  numTimes = 0;

  /**
   * 检测视频控件
   * @param success
   * @param fail
   */
  checkVideoControl(success, fail) {

    if (this.connected) return;
    if (this.isInstall) return;
    const sucFun = () => {
      // 成功的操作
      this.isInstall = true;
      // 给控件足够的时间打开然后重连websocket
      setTimeout(() => {
        success && success();
      }, 5000);
    };
    const failFun = () => {
      this.showDownLoadMsg();
    };
    const openVideoClient = () => {
      if (window.location.hash == '#/RealVideo' || window.location.hash == '#/FaceDetect' || window.location.hash == '#/PlaybackVideo') return true;
    }
    if (!isInit) {

      ElMessage.warning("正在检测视频控件，请不要离开页面！");
      isInit = true;
      // this.openApplication(
      //   false,
      //   e => {
      //     fail && fail();
      //     ElMessage.warning(
      //       "视频控件自动打开失败，若需要查看视频，请手动打开！"
      //     );
      //     failFun();
      //     // this.checkVideoControl(sucFun, failFun);
      //   },
      //   sucFun
      // );
      setTimeout(() => {
        failFun();
      }, 2000);

    } else if (isInit && !this.isInstall) {
      // 未安装
      if (!this.isDownOpen) {
        failFun();
      }
    }
  }

  /**
   * 显示下载
   */
  showDownLoadMsg() {
    if (this.isDownOpen === true) {
      return;
    }
    this.isDownOpen = true;
    // utilLog.danger("the robot has video control!!!")
    if (!this.connected) {
      //
      this.downLoadVideoConfirm();
    }
  }

  /**
   * 下载视频客户端
   * @param title
   * @param content
   * @param success
   * @param cancel
   */
  downLoadVideoConfirm(title, content, success, cancel) {
    ElMessageBox.confirm(
      content || "您的电脑未安装或未启动视频控件,未安装请点击下载按钮下载,如已下载请用桌面快捷方式打开视频控件！",
      title || "视频控件未安装", {
        customClass: "videoControlConfirm",
        confirmButtonText: "下载"
      }
    ).then(
      async e => {
        console.log(e);
        if (e === "confirm") {
          // const res = await api.getNewVideoControl(); // 查询到最新版本的版本
          const res = ""; // 查询到最新版本的版本
          const fileName = "VideoClientApp" || res.data.controlName;
          util.downFile(window.PAGE_PATH.videoControlIP, fileName);
          ElMessage.success("请下载成功，并安装后重新刷新页面。");
          success && success();
        } else {
          // 选择不下载
          console.warn("no control was installed at your computer!");

          // this.vWs.intervalFun = clearInterval(this.vWs.intervalFun);
          cancel && cancel();
        }
      },
      () => {

        isInit = true;
        this.isDownOpen = false;
        // this.isInstall = true;
        cancel && cancel();
      }
    ).catch(() => {
      isInit = false;
      this.isDownOpen = false
      cancel && cancel();
    })
  }

  /**
   * 打开exe应用
   * @param event
   * @param url
   * @param fail
   * @param success
   */
  openApplication(url, fail, success) {
    if (!url) {
      return;
    }
    if (this.isInstall) {
      return;
    }
    protocolCheck(url, fail, success);
  }
}
export default CheckVideo;